import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { DeleteOutline, Edit } from '@material-ui/icons';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { DeletePopUp, EmptyCollection, PageLoader, STableLoader } from "../../../shared_elements";
import { globalDeleteService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import AddEditEngineLlpsConfig from "../components/AddEditEngineLlpsConfig";
import EngineLlpsConfigList from "../components/EngineLlpsConfigList";
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";

const ModuleHeader = ({deleteModule}) => (
    <TableHead>
        <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>LLP Type</TableCell>
            <TableCell>Remarks</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Last Updated By</TableCell>
            {!deleteModule ? <TableCell align="right">Action(s)</TableCell> : '' }
        </TableRow>
    </TableHead>
);

const EngineLlpsModule = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [moduleDescriptionInfo, setModuleDescriptionInfo] = useState({ list: [] });
    const [modal, setModal] = useState({ modal: false, data: null, type: '', callTo: '' });
    const [deleteModal, setDeleteModal] = useState({ modal: false, data: null });
    const [deleteDescription, setDeleteDescription] = useState({ modal: false, data: null });
    const [revertDescription, setRevertDescription] = useState({ modal: false, data: null });
    const [revertModule, setRevertModule] = useState({ modal: false, data: null });
    const [circularLoader, setCircularloader] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    
    useEffect(() => { 
        getModule({},'skeletonLoader') 
        trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Config (Module)', event_type: 'Page Visited' })
    }, [])

    const getModule = (query = {}, loaderType) => {
     loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService('config-data/llp-module/', query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setModuleDescriptionInfo(response?.data?.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            }) 
    }

    const onDeleteDescription = () => {
        setCircularloader(true)
        const ids = deleteDescription?.data?.id
        globalDeleteService(`config-data/llp-description/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteDescription({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Deleted`,
                        event_desc: 'Module Description Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    getModule()
                    setDeleteDescription({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Deleted`,
                        event_desc: 'Module Description Deletion Failed',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                }
                setCircularloader(false)
            })
    }

    const onDeleteModule = () => {
        setCircularloader(true)
        const ids = deleteModal?.data?.id
        globalDeleteService(`config-data/llp-module/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteModal({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Module Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteModal({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Module Deletion Failed',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                }
                setCircularloader(false)
            })
    }

    const onRevertDescription = () => {
        setCircularloader(true)
        const ids = revertDescription?.data?.id
        globalPutService(`config-data/llp-description/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertDescription({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Reverted`,
                        event_desc: 'Module Description Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertDescription({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Reverted`,
                        event_desc: 'Module Description Revertion Failed',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                }
                setCircularloader(false)
            })
    }

    const onRevertModule = () => {
        setCircularloader(true)
        const ids = revertModule?.data?.id
        globalPutService(`config-data/llp-module/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertModule({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Module Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertModule({ modal: false, data: null })
                    getModule()
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Config',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Module Revertion Failed',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                }
                setCircularloader(false)
            })
    }

     const getConfirmColor = () => {
        if (revertDescription?.modal || revertModule?.modal) return "primary";
        if (deleteModal?.modal || deleteDescription?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertDescription?.modal || revertModule?.modal) return "Revert";
        if (deleteModal?.modal || deleteDescription?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertDescription?.modal) return revertDescription.modal;
        if (revertModule?.modal) return revertModule.modal;
        if (deleteDescription?.modal) return deleteDescription?.modal;
        if (deleteModal?.modal) return deleteModal.modal;
        return null;
    };

    const getTitle = () => {
        if (revertDescription?.modal) return "Revert Description";
        if (revertModule?.modal) return "Revert Module"
        if (deleteModal?.modal) return "Delete Module";
        if (deleteDescription?.modal) return "Delete Description"
        return "";
    };

    const getContent = () => {
        if (revertDescription?.modal || revertModule?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteModal?.modal || deleteDescription?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertDescription?.modal) {
            setRevertDescription({ modal: false, data: null });
        } else if (revertModule?.modal) {
            setRevertModule({ modal: false, data: null });
        } else if (deleteDescription?.modal) {
            setDeleteDescription({ modal: false, data: null });
        } else {
            setDeleteModal({ modal: false, data: null });
        } 
    };

    const getDeleteRecordFn = () => {
        if (revertDescription?.modal) return onRevertDescription;
        if (revertModule?.modal) return onRevertModule;
        if (deleteDescription?.modal) return onDeleteDescription;
        if (deleteModal?.modal) return onDeleteModule;
        return null;
    };
    
    return (
        <>
            <div square>
                <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                    <Grid item md={12} xs={12} sm={12} >
                        <Button onClick={() => setModal({ modal: true, data: null, type: 'add', callTo: 'parent' })} color="primary" size='small' variant="contained" style={{ float: "right" }} >
                             ADD MODULE 
                        </Button>
                    </Grid>
                </Grid>
                {skeletonLoader ? <STableLoader count={6} /> : moduleDescriptionInfo?.list?.length?
                <Paper style={{ paddingTop: "15px", maxHeight: "76.5vh", overflow: "auto" }}>
                    {moduleDescriptionInfo?.list?.map((item, index) => (
                        <Accordion key={item.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" >
                                    <div>
                                        <Typography> <div style={{fontSize: '13px', color: item?.deleted_at ? "lightgray" : '' }}>LLP Module</div></Typography>
                                        <Typography> <div style={{fontSize: '16px', fontWeight: 'bold', color: item?.deleted_at ? "lightgray" : '' }}>{item.name}</div></Typography>
                                    </div>
                                    <Box display="flex" alignItems="center">
                                        {!item?.deleted_at ?
                                        <Tooltip title="Edit" arrow>
                                            <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); setModal({ modal: true, data: item, type: 'edit', callTo: 'parent' }) }}>
                                                <Edit fontSize="small" />
                                            </IconButton>
                                        </Tooltip> : null}
                                        {!item?.deleted_at ?
                                        <Tooltip title="Add" arrow>
                                            <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); setModal({ modal: true, data: item, type: 'add', callTo: 'child' }); }} >
                                                <AddCircleOutlineIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip> : null}
                                        {!item?.deleted_at ?
                                        <Tooltip title="Delete" arrow>
                                            <IconButton size="small" color="secondary" onClick={(e) => { e.stopPropagation(); setDeleteModal({ modal: true, data: item, callTo: 'parent' }) }}>
                                                <DeleteOutline fontSize="small" />
                                            </IconButton>
                                        </Tooltip> : null}
                                        {item?.deleted_at ?
                                            <Tooltip title='Revert' arrow>
                                                <img
                                                    src={RevertIcon}
                                                    alt="Revert Icon"
                                                    onClick={(e) => { e.stopPropagation(); setRevertModule({ modal: true, data: item })}}
                                                    style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize: "1.25rem", marginLeft: "2px" }}
                                                    className="last-icon"
                                                />
                                            </Tooltip>
                                            : null}
                                    </Box>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table className="mui-table-format" >
                                    <ModuleHeader deleteModule={item?.deleted_at}/>
                                    <TableBody>
                                        {item?.description_module?.map((description, index) => (
                                            <EngineLlpsConfigList
                                                item={description}
                                                index={index}
                                                deleteModule={item?.deleted_at}
                                                onRevert={setRevertDescription}
                                                onEditFn={() => setModal({ modal: true, data: description, type: 'edit', callTo: 'child' })}
                                                onDelete={() => setDeleteDescription({ modal: true, data: description, callTo: 'child' })}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Paper>:<EmptyCollection/>} 
                {isLoading ? <PageLoader /> : null} 
            </div>

            {modal.modal ?
                <AddEditEngineLlpsConfig
                    modalData={modal}
                    toggleModalFn={() => setModal({ modal: false, data: null, type: '', callTo: '' })}
                    getResponseBack={() => getModule()}
                    circularloader={circularLoader}
                /> : null
               }
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                    circularloader={circularLoader}
                />
        </>
    );
};

export default EngineLlpsModule